import React from "react";
import { CUSTOMER_CHAT } from "./customerExperienceContent";

const CustomerExperiencePhone = () => (
  <div
    className="relative mx-auto w-full max-w-[280px] sm:max-w-[300px]"
    data-testid="customer-experience-phone"
  >
    <div className="absolute -inset-4 bg-gradient-to-br from-orange-500/15 via-transparent to-teal-500/10 rounded-[2.5rem] blur-2xl pointer-events-none" />

    <div className="relative rounded-[2rem] border border-white/10 bg-[#0c1018] shadow-2xl shadow-black/50 overflow-hidden">
      <div className="px-4 pt-3 pb-2 border-b border-white/[0.06] bg-white/[0.02]">
        <div className="flex items-center justify-between mb-2">
          <span className="text-[10px] font-mono text-gray-500">
            {CUSTOMER_CHAT.statusTime} · {CUSTOMER_CHAT.statusDay}
          </span>
          <div className="flex items-center gap-1.5">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-60" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-400" />
            </span>
            <span className="text-[9px] font-mono text-teal-400/90 tracking-wider">ONLINE</span>
          </div>
        </div>
        <p className="text-xs font-semibold text-white">Oz Exteriors</p>
        <p className="text-[10px] text-gray-500 font-body">Typically replies instantly</p>
      </div>

      <div className="p-4 space-y-3 min-h-[260px] sm:min-h-[280px]">
        {CUSTOMER_CHAT.messages.map((message) => {
          const isCustomer = message.role === "customer";
          const isAi = message.role === "ai";

          return (
            <div
              key={message.id}
              className={`flex ${isCustomer ? "justify-end" : "justify-start"}`}
            >
              <div
                className={`max-w-[88%] rounded-2xl px-3 py-2 text-[11px] sm:text-xs leading-snug font-body ${
                  isCustomer
                    ? "bg-orange-500/20 text-orange-50 rounded-br-md border border-orange-500/20"
                    : message.highlight
                      ? "bg-teal-500/15 text-teal-100 rounded-bl-md border border-teal-500/30 font-semibold"
                      : "bg-white/[0.06] text-gray-200 rounded-bl-md border border-white/[0.06]"
                }`}
              >
                {message.text}
              </div>
            </div>
          );
        })}
      </div>

      <div className="px-4 py-2.5 border-t border-white/[0.06] bg-black/20">
        <div className="h-8 rounded-full border border-white/[0.08] bg-white/[0.02] flex items-center px-3">
          <span className="text-[10px] text-gray-600 font-mono">iMessage</span>
        </div>
      </div>
    </div>
  </div>
);

export default CustomerExperiencePhone;
